import { formatBookingDateTime } from '@/lib/utils/dates'

/**
 * Departure date for the tours UI: weekday, day, month and time.
 *
 * Pinned to the booking timezone (America/El_Salvador) and to the active app
 * language. Every tours screen used to roll its own
 * `new Date(iso).toLocaleString('es-SV', …)`, which showed Spanish dates to
 * English users and rendered in the device timezone instead of where the
 * departure actually happens.
 */
export function formatTourDeparture(iso: string, locale: string): string {
  return formatBookingDateTime(iso, locale, {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    hour: 'numeric',
    minute: '2-digit',
    year: undefined,
  })
}
